import { useInfiniteQuery } from "@tanstack/react-query";
import api from "../api";

const PAGE_SIZE = 24;

export function useEventHistoryQuery() {
  return useInfiniteQuery({
    queryKey: ["events", "history"],
    initialPageParam: 1,
    queryFn: async ({ pageParam }) => {
      const response = await api.get(`/api/events/history?page=${pageParam}&limit=${PAGE_SIZE}`);
      return response.data ?? [];
    },
    getNextPageParam: (lastPage, pages) => lastPage.length === PAGE_SIZE ? pages.length + 1 : undefined,
  });
}
